import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/UI/Breadcrumbs/Breadcrumbs.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/app/services/websites-for-construction-companies/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/runner/work/udata-site/udata-site/components/UI/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/public/success_stories/staff_power_website_screen.webp");
